import React from "react";
import FormView from "./FormView";

export default function Preconsultation() {
    return <FormView />;
}
